export default __webpack_public_path__ + "static/media/F_Ferro.f3a522b8.mp3";